import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import Input from 'components/ui/Input';

const ROLES = [
  { value: 'ADMIN', label: 'Admin' },
  { value: 'OPERATOR', label: 'Operador' },
  { value: 'CUSTOMER_USER', label: 'Usuario Cliente' },
];

const ORGANIZATIONS = [
  { value: 'techcorp', label: 'TechCorp S.A.S.' },
  { value: 'innovasoft', label: 'InnovaSoft Ltda.' },
  { value: 'datagroup', label: 'DataGroup Colombia' },
  { value: 'solucionesit', label: 'Soluciones IT S.A.' },
  { value: 'digitalco', label: 'DigitalCo S.A.S.' },
];

const AddUserModal = ({ onClose, onAdd }) => {
  const [form, setForm] = useState({ name: '', email: '', role: 'CUSTOMER_USER', organization: 'techcorp', phone: '' });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!form?.name?.trim()) e.name = 'El nombre es requerido';
    if (!form?.email?.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(form?.email)) e.email = 'Correo electrónico inválido';
    return e;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    const errs = validate();
    if (Object.keys(errs)?.length > 0) { setErrors(errs); return; }
    onAdd(form);
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-lg z-10 overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-teal-100 flex items-center justify-center">
              <Icon name="UserPlus" size={18} color="#0F766E" />
            </div>
            <h3 className="text-base font-bold text-gray-800 font-heading">Agregar Usuario</h3>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-400 transition-colors">
            <Icon name="X" size={16} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <Input
            label="Nombre completo"
            type="text"
            placeholder="Ej: Juan Carlos Pérez"
            value={form?.name}
            onChange={(e) => setForm(f => ({ ...f, name: e?.target?.value }))}
            error={errors?.name}
            required
          />
          <Input
            label="Correo electrónico"
            type="email"
            placeholder="usuario@empresa.com"
            value={form?.email}
            onChange={(e) => setForm(f => ({ ...f, email: e?.target?.value }))}
            error={errors?.email}
            required
          />
          <Input
            label="Teléfono (opcional)"
            type="tel"
            placeholder="+57 300 000 0000"
            value={form?.phone}
            onChange={(e) => setForm(f => ({ ...f, phone: e?.target?.value }))}
          />

          <div>
            <label className="block text-sm font-medium text-gray-700 font-caption mb-1.5">Organización <span className="text-red-500">*</span></label>
            <select
              value={form?.organization}
              onChange={(e) => setForm(f => ({ ...f, organization: e?.target?.value }))}
              className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 bg-white font-caption text-gray-700"
            >
              {ORGANIZATIONS?.map(o => <option key={o?.value} value={o?.value}>{o?.label}</option>)}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 font-caption mb-1.5">Rol <span className="text-red-500">*</span></label>
            <select
              value={form?.role}
              onChange={(e) => setForm(f => ({ ...f, role: e?.target?.value }))}
              className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 bg-white font-caption text-gray-700"
            >
              {ROLES?.map(r => <option key={r?.value} value={r?.value}>{r?.label}</option>)}
            </select>
          </div>

          <div className="flex gap-3 justify-end pt-2">
            <Button variant="outline" type="button" onClick={onClose}>Cancelar</Button>
            <Button variant="default" type="submit" iconName="UserPlus" iconPosition="left">Agregar Usuario</Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUserModal;